import { render, staticRenderFns } from "./DodDuplicateFoundModal.vue?vue&type=template&id=2d60aab7&scoped=true&"
import script from "./DodDuplicateFoundModal.vue?vue&type=script&lang=js&"
export * from "./DodDuplicateFoundModal.vue?vue&type=script&lang=js&"
import style0 from "./DodDuplicateFoundModal.vue?vue&type=style&index=0&id=2d60aab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60aab7",
  null
  
)

export default component.exports